import { supabase, API_BASE } from './supabase';

async function authHeader() {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
}

async function jsonFetch(path, opts = {}) {
    const { method = 'GET', auth = false, body, headers: extraHeaders = {} } = opts;
    const headers = {
        'Content-Type': 'application/json',
        ...(auth ? await authHeader() : {}),
        ...extraHeaders,
    };
    // Build fetch init with only known, accepted keys — never spread opts directly
    // so stray properties (auth, plain-object body) cannot leak into the fetch call
    // and accidentally mark the request/response stream as consumed.
    const init = { method, headers };
    if (body != null) init.body = JSON.stringify(body);
    const res = await fetch(`${API_BASE}${path}`, init);
    const text = await res.text();
    let data;
    try { data = text ? JSON.parse(text) : null; } catch { data = text; }
    if (!res.ok) {
        const msg = (data && (data.detail || data.error)) || res.statusText;
        throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
    return data;
}

export const api = {
    me: () => jsonFetch('/me', { method: 'GET', auth: true }),
    bootstrapOrg: (payload) => jsonFetch('/bootstrap/organization', { method: 'POST', auth: true, body: payload }),
    inviteAgent: (payload) => jsonFetch('/admin/invite-agent', { method: 'POST', auth: true, body: payload }),
    createTeamMember: (payload) => jsonFetch('/team/create-member', { method: 'POST', auth: true, body: payload }),
    deleteTeamMember: (member_id) => jsonFetch('/team/delete-member', { method: 'POST', auth: true, body: { member_id } }),
    regenerateKey: (sourceType) => jsonFetch('/admin/regenerate-key', { method: 'POST', auth: true, body: { source_type: sourceType } }),
    quickAdd: (payload) => jsonFetch('/leads/quick-add', { method: 'POST', auth: true, body: payload }),
    parseEmail: (subject, body, organization_id) => jsonFetch('/leads/email-parser', { method: 'POST', auth: true, body: { subject, body, organization_id } }),
    testWebsiteLead: (apiKey, payload) => jsonFetch('/leads/website', { method: 'POST', headers: { 'X-API-Key': apiKey }, body: payload }),
    health: () => jsonFetch('/health'),
};
